import React, { useEffect } from "react";
import ButtonRed from "../ButtonRed/ButtonRed";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import img1 from "../../assets/images/bydgoszcz/cigar/gb_8.jpg";
import img2 from "../../assets/images/bydgoszcz/cigar/gb_9.jpg";
import img3 from "../../assets/images/bydgoszcz/cigar/gb_12.jpg";

const CigarPageBydgoszcz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center px-4 py-10">
      <FloatingLogoAndButton />
      <div className="mb-20"></div>

      {/* HERO */}
      <section className="max-w-4xl text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Palarnia cygar Bydgoszcz
        </h1>
        <p className="text-lg opacity-90">
          Whitebull to steakhouse z palarnią cygar w Bydgoszczy – miejsce, gdzie
          kolacja zamienia się w doświadczenie premium.
        </p>
      </section>

      {/* GALERIA */}
      <section className="w-full max-w-5xl mb-12">
        <div className="flex flex-col md:flex-row gap-4">
          <img
            src={img1}
            alt="palarnia cygar Bydgoszcz wnętrze Whitebull"
            className="w-full md:w-1/2 h-72 object-cover"
          />
          <img
            src={img2}
            alt="cygaro z dymem Whitebull Bydgoszcz"
            className="w-full md:w-1/2 h-72 object-cover"
          />
        </div>
        <div className="mt-4">
          <img
            src={img3}
            alt="cygaro whisky Whitebull Bydgoszcz klimat"
            className="w-full h-72 object-cover"
          />
        </div>
      </section>

      {/* OPIS */}
      <section className="max-w-3xl text-center mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          Palarnia cygar w centrum Bydgoszczy
        </h2>
        <p className="mb-4 opacity-90">
          Nasza palarnia cygar to przestrzeń dla osób, które cenią jakość,
          spokój i klimat. To idealne miejsce na zakończenie wieczoru – po
          kolacji, spotkaniu biznesowym lub wyjściu ze znajomymi.
        </p>
        <p className="opacity-90">
          W Whitebull łączymy steakhouse,{" "}
          <a href="/grill-przy-stole-bydgoszcz" className="underline">
            Grill Father (grill przy stole)
          </a>{" "}
          i cigar lounge, tworząc jedno z najbardziej unikalnych doświadczeń w
          Bydgoszczy.
        </p>
      </section>

      {/* USP */}
      <section className="max-w-3xl mb-12">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Dlaczego warto?
        </h2>
        <ul className="space-y-3 text-center opacity-90">
          <li>🥩 steakhouse z wysokiej jakości wołowiną</li>
          <li>🔥 grill przy stole – Grill Father</li>
          <li>🚬 palarnia cygar w Bydgoszczy</li>
          <li>🌙 klimat premium i spokojna atmosfera</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="text-center mb-12">
        <h2 className="text-2xl mb-4">Zarezerwuj stolik</h2>
        <p className="mb-6 opacity-90">
          Doświadcz steakhouse’u i palarni cygar w jednym miejscu.
        </p>

        <ButtonRed
          text={"Rezerwuj stolik"}
          type={"outputLink"}
          url={"https://zjedz.my/whitebull-bydgoszcz"}
        />
      </section>

      {/* 🔥 HUB WIEDZY (BARDZO WAŻNE SEO) */}
      <section className="text-center mb-12 space-y-3">
        <p className="opacity-70">Dowiedz się więcej o cygarach:</p>

        <a
          href="/historia-cygar"
          className="block underline hover:text-red-500"
        >
          → Historia cygar
        </a>

        <a href="/rodzaje-cygar" className="block underline hover:text-red-500">
          → Rodzaje cygar
        </a>

        <a
          href="/jak-palic-cygaro"
          className="block underline hover:text-red-500"
        >
          → Jak palić cygaro
        </a>

        <a
          href="/jak-przechowywac-cygara"
          className="block underline hover:text-red-500"
        >
          → Jak przechowywać cygara
        </a>

        <a
          href="/jakie-cygaro-na-poczatek"
          className="block underline hover:text-red-500"
        >
          → Jakie cygaro na początek
        </a>
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mb-12">
        <h2 className="text-2xl mb-6 text-center">
          FAQ – Palarnia cygar Bydgoszcz
        </h2>

        <div className="space-y-6 opacity-90">
          <div>
            <h3 className="font-semibold">
              Gdzie zapalić cygaro w Bydgoszczy?
            </h3>
            <p>
              Jednym z najlepszych miejsc jest Whitebull – steakhouse z palarnią
              cygar, oferujący komfortową przestrzeń do relaksu.
            </p>
          </div>

          <div>
            <h3 className="font-semibold">
              Czy w Whitebull można kupić cygara?
            </h3>
            <p>
              Tak, oferujemy selekcję cygar oraz możliwość ich degustacji na
              miejscu.
            </p>
          </div>

          <div>
            <h3 className="font-semibold">Czy trzeba rezerwować?</h3>
            <p>Zalecamy rezerwację, szczególnie w weekendy.</p>
          </div>
        </div>
      </section>

      {/* BACK */}
      <section className="text-center">
        <a href="/bydgoszcz" className="underline opacity-70">
          ← Powrót do restauracji w Bydgoszczy
        </a>
      </section>
    </div>
  );
};

export default CigarPageBydgoszcz;
